import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';

const inp = 'w-full px-3 py-2 bg-slate-800 border border-slate-600 rounded-lg text-white text-sm';
const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const EMPTY = { method: 'ach', amount: '', name_on_account: '', routing_number: '', account_number: '', account_type: 'checking', street: '', city: '', state: '', postal_code: '' };

const Field = ({ k, f, set, ...rest }) => (
  <input value={f[k]} onChange={(e) => set(k, e.target.value)} className={inp} data-testid={`bank-wd-${k.replace(/_/g, '-')}`} {...rest} />
);

export const WithdrawForm = ({ feePct, busy, onSubmit }) => {
  const [f, setF] = useState(EMPTY);
  const set = (k, v) => setF({ ...f, [k]: v });
  const amount = parseFloat(f.amount);
  const g = Math.round((amount || 0) * 100); const fee = Math.round((g * feePct) / 100 + 1e-9);
  const wire = f.method === 'wire';
  const ok = amount >= 1 && f.name_on_account.trim().length > 1 && /^\d{9}$/.test(f.routing_number) && /^\d{4,17}$/.test(f.account_number)
    && (!wire || (f.street && f.city && f.state.length === 2 && f.postal_code));
  return (
    <div className="space-y-3" data-testid="bank-withdraw-form">
      <div className="grid grid-cols-2 gap-2">
        {['ach', 'wire'].map(m => (
          <button key={m} type="button" onClick={() => set('method', m)} data-testid={`bank-wd-method-${m}`}
            className={`py-2 rounded-lg text-sm font-semibold transition-colors ${f.method === m ? 'bg-emerald-600 text-white' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}>
            {m === 'ach' ? 'ACH (1-3 days)' : 'Wire (same day)'}
          </button>
        ))}
      </div>
      <Field k="amount" f={f} set={set} type="number" min="1" step="0.01" placeholder="Amount (USD)" />
      <Field k="name_on_account" f={f} set={set} placeholder="Name on the receiving account" />
      <div className="grid grid-cols-2 gap-2">
        <Field k="routing_number" f={f} set={set} inputMode="numeric" maxLength={9} placeholder="Routing number" />
        <Field k="account_number" f={f} set={set} inputMode="numeric" maxLength={17} placeholder="Account number" />
      </div>
      <select value={f.account_type} onChange={(e) => set('account_type', e.target.value)} className={inp} data-testid="bank-wd-account-type">
        <option value="checking">Checking</option><option value="savings">Savings</option>
      </select>
      {wire && (
        <div className="grid grid-cols-2 gap-2" data-testid="bank-wd-wire-address">
          <Field k="street" f={f} set={set} placeholder="Recipient street" />
          <Field k="city" f={f} set={set} placeholder="City" />
          <Field k="state" f={f} set={set} maxLength={2} placeholder="State (TX)" />
          <Field k="postal_code" f={f} set={set} placeholder="ZIP" />
        </div>
      )}
      <div className="text-xs text-slate-400 bg-slate-800/60 rounded-lg p-3 space-y-1" data-testid="bank-wd-breakdown">
        <p className="flex justify-between"><span>Fee ({feePct}%)</span><span>{money(fee / 100)}</span></p>
        <p className="flex justify-between text-white font-semibold"><span>Sent to the receiving bank</span><span>{money((g - fee) / 100)}</span></p>
      </div>
      <button disabled={busy || !ok} onClick={() => onSubmit({ ...f, amount }, () => setF(EMPTY))} data-testid="bank-wd-submit"
        className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-40 text-white rounded-lg text-sm font-semibold flex items-center justify-center gap-2 transition-colors">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Request {f.method.toUpperCase()} withdrawal
      </button>
    </div>
  );
};
